import React from "react";
import styles from "./CardListSkeleton.module.scss";

export const CardListSkeleton: React.FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.titleSkeleton} />
      <div className={styles.items}>
        {Array.from({ length: 2 }).map((_, i) => (
          <div key={i} className={styles.cardItem}>
            <div className={styles.cardLeft}>
              <div className={styles.iconSkeleton} />
              <div className={styles.numberSkeleton} />
            </div>
            <div className={styles.trashSkeleton} />
          </div>
        ))}
        <div className={styles.addCardSkeleton} />
      </div>
    </div>
  );
};
